import { Navbar, Nav, NavItem, Button, Badge } from 'reactstrap'
import { NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import { setUniqueContractVisible } from 'actions/contractSelection'

const TopNav = ({ setUserPanelOpen, userPanelOpen }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const dispatch = useDispatch()

  return (
    <Navbar expand className="topNav">
      <Nav navbar>
        {paths.map((i, index) => (
          <NavItem key={index}>
            <NavLink
              to={i.dir + i.link}
              activeClassName="active"
              className="nav-link"
              onClick={() => {
                dispatch(setUniqueContractVisible(null))
              }}
              isActive={() =>
                (i.dir && location.pathname.match('^' + i.dir)) ||
                location.pathname.match('^' + i.link)
              }
            >
              <span >
                <svg className="mr-1" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d={i.icon}/></svg>
                {t(i.text)} {i.nb && <Badge>{i.nb}</Badge>}
              </span>
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <Nav className="ml-auto" navbar >
        {
          pathsAdmin.map((i, index) => (
            <NavItem key={index}>
              <NavLink
                to={i.dir + i.link}
                activeClassName="active"
                className="nav-link"
                onClick={() => {
                  dispatch(setUniqueContractVisible(null))
                }}
                isActive={() =>
                  (i.dir && location.pathname.match('^' + i.dir)) ||
                  location.pathname.match('^' + i.link) ||
                  location.pathname.match('^/transactions')
                }
              >
                <span>
                  <i style={{ color: '#171D21' }} className={i.icon} /> {t(i.text)} {i.nb && <Badge>{i.nb}</Badge>}
                </span>
              </NavLink>
            </NavItem>
          ))}
        <NavItem className="menu-user">
          <Button color="link" title="" onClick={() => setUserPanelOpen(!userPanelOpen)}>
            <svg style={{ color: '#171D21' }} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M360-390q-21 0-35.5-14.5T310-440q0-21 14.5-35.5T360-490q21 0 35.5 14.5T410-440q0 21-14.5 35.5T360-390Zm240 0q-21 0-35.5-14.5T550-440q0-21 14.5-35.5T600-490q21 0 35.5 14.5T650-440q0 21-14.5 35.5T600-390ZM480-160q134 0 227-93t93-227q0-24-3-46.5T786-570q-21 5-42 7.5t-44 2.5q-91 0-172-39T390-708q-32 78-91.5 135.5T160-486v6q0 134 93 227t227 93Zm0 80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-54-715q42 70 114 112.5T700-640q14 0 27-1.5t27-3.5q-42-70-114-112.5T480-800q-14 0-27 1.5t-27 3.5ZM177-581q51-29 89-75t57-103q-51 29-89 75t-57 103Zm249-214Zm-103 36Z"/></svg>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87"/><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/></svg>
          </Button>
        </NavItem>
      </Nav>
    </Navbar>
  )
}

export default TopNav

export const paths = [
  {
    text: 'topNav.execution',
    icon: "M200-120q-33 0-56.5-23.5T120-200v-640h80v640h640v80H200Zm40-120v-360h160v360H240Zm200 0v-560h160v560H440Zm200 0v-200h160v200H640Z",
    dir: '',
    link: '/exec',
  },
  {
    text: 'topNav.market',
    icon: "m140-220-60-60 300-300 160 160 284-320 56 56-340 384-160-160-240 240Z",
    dir: '',
    link: '/market',
  },
  {
    text: 'topNav.strategy',
    icon: "M280-280h80v-280h-80v280Zm160 0h80v-400h-80v400Zm160 0h80v-160h-80v160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z",
    dir: '',
    link: '/strategy',
  },
  {
    text: 'topNav.deals',
    icon: "M200-640v440h560v-440H640v320l-160-80-160 80v-320H200Zm0 520q-33 0-56.5-23.5T120-200v-499q0-14 4.5-27t13.5-24l50-61q11-14 27.5-21.5T250-840h460q18 0 34.5 7.5T772-811l50 61q9 11 13.5 24t4.5 27v499q0 33-23.5 56.5T760-120H200Zm16-600h528l-34-40H250l-34 40Zm184 80v190l80-40 80 40v-190H400Zm-200 0h560-560Z",
    dir: '',
    link: '/deals',
  },
  {
    text: 'topNav.alerts',
    icon: "M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z",
    dir: '',
    link: '/alerts',
  },
]

export const pathsAdmin = [
  {
    text: 'topNav.administration',
    icon: 'icon-coche-check',
    dir: '',
    link: '/admin',
  },
]
